import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// import 'hammerjs';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialUIModule } from './material-ui.module';
import { DialogInstallPromptDialog } from './dialogs/install-prompt-dialog/install-prompt-dialog.component';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { DialogInstallPromptIOSDialog } from './dialogs/install-prompt-dialog-ios/install-prompt-dialog-ios.component';
import { DialogBrowserInfoDialog } from './dialogs/browser-info-dialog/browser-info-dialog.component';
import { DialogDeviceDebugDialog } from './dialogs/device-debug-dialog/device-debug-dialog.component';
import { ConfirmZerosDialogComponent } from './dialogs/confirm-zeros-dialog/confirm-zeros-dialog.component';
import { ColorCircleModule } from 'ngx-color/circle';
// Shared Components
// import { ProgressBarComponent } from '../common/progress-bar/progress-bar.component';
// import { DebounceClickDirective } from './directives/debounce-click.directive';


// Pipes



// Shared Sevices
import { FunctionCallService } from './services/function-calls.service';
import { AuthGuard } from './services/auth-guard';
import { AuthService } from './services/auth.service';
import { ScoreTrackerService } from './services/score-tracker.service';
import { SMSService } from './services/sms.service';
import { AppNavigationService } from './services/app-navigation.service';
import { EventsListPlayerService } from './services/events-list-player.service';
import { WebSocketService } from './services/websocket.service';
import { WifiStatusService } from './services/wifi-status.service';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { WebSocketRxjsService } from './services/websocket-rxjs.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';



// Manipulate the Image before sending to the server



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MaterialUIModule,
        FlexLayoutModule,
        NgxSpinnerModule,
        ColorCircleModule
    ],
    declarations: [
        DialogInstallPromptDialog,
        DialogInstallPromptIOSDialog,
        DialogBrowserInfoDialog,
        DialogDeviceDebugDialog,
        ConfirmZerosDialogComponent,
        ProgressBarComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        MaterialUIModule,
        FlexLayoutModule,
        DialogInstallPromptDialog,
        DialogInstallPromptIOSDialog,
        DialogBrowserInfoDialog,
        DialogDeviceDebugDialog,
        ConfirmZerosDialogComponent,
        NgxSpinnerModule,
        ColorCircleModule
    ]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
    return {  
      ngModule: SharedModule,
      providers: [
        GoogleAnalyticsService,
        FunctionCallService,
        AuthGuard,
        AuthService,
        ScoreTrackerService,
        SMSService,
        AppNavigationService,
        EventsListPlayerService,
        WebSocketService,
        WifiStatusService,
        WebSocketRxjsService,
        NgxSpinnerService
      ]
    };
  }
 }
